import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
//
// Iter 62 — minimal-friction login. We removed the "Close the books with
// precision" marketing landing page (this is an internal tool, not a SaaS
// signup flow). When an unauthenticated user hits /login we immediately
// punt them at the Emergent OAuth screen. The fallback button below is for
// the unlikely case where the redirect doesn't fire (popup blockers,
// reduced-motion, etc.) or when JS fails.
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const handleSignIn = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  useEffect(() => {
    if (loading) return;
    if (user) {
      navigate("/", { replace: true });
      return;
    }
    // Fire the OAuth redirect on the next tick so the brief "redirecting"
    // marker has time to paint — this avoids a blank-white-screen feel.
    const t = setTimeout(handleSignIn, 60);
    return () => clearTimeout(t);
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen w-full grid place-items-center bg-white text-slate-700" data-testid="login-redirecting">
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-2.5">
          <div className="h-8 w-8 bg-slate-900 grid place-items-center rounded-sm">
            <span className="text-white font-display font-black text-sm">C</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-slate-900 tracking-tight">Close</div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-slate-400">Powered by Prysm Financial</div>
          </div>
        </div>
        <div className="text-sm text-slate-500">Redirecting you to sign in…</div>
        <button
          onClick={handleSignIn}
          data-testid="google-signin-button"
          className="text-xs text-slate-500 hover:text-slate-900 underline underline-offset-4"
        >
          Click here if you aren't redirected automatically
        </button>
      </div>
    </div>
  );
}
